import DIApi from './_diApi';

class FundStructureAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'FundStructures';
}

export default new FundStructureAPI();
